
export const removeLineBreak = (value) => {
  if (value !== null) {
    const result = value?.replace(/<\/?p[^>]*>/g, '<p style="margin-block:1px !important; font-size: 14px;line-height: 18px;">');
    const duplicate = result.replace(/(<p><br><\/p>)+/g, "$1")
    const regex = /(<span[^>]*style="[^"]*?)(background-color: rgba\(0, 0, 0, 0.04\);)([^"]*?"[^>]*>)/g;
    const updatedHtmlText = duplicate?.replace(regex, "$1background-color: transparent;$3");
    return updatedHtmlText
  }
  return value
}


export const extractFilename = (contentDisposition) => {
  if (!contentDisposition) return null;
  const match =
    contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i) ||
    contentDisposition.match(/filename="?([^"]+)"?/i);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]).replace(/(^"|"$)/g, "");
  } catch {
    return match[1].replace(/(^"|"$)/g, "");
  }
};

export const sanitizeMessageForStorage = (html = "") => {
  if (!html) return html;
  return html.replace(
    /<img([^>]*data-file-id=["'][^"']+["'][^>]*?)\s+src=["']blob:[^"']+["']([^>]*?)>/gi,
    "<img$1$2>"
  );
};

export const formatFileSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};

export const isImageFilename = (name = "") =>
  /\.(png|jpe?g|gif|webp|svg|bmp|ico)$/i.test(name);